import React from "react";

export default function CommunityPulseLoader({
  community,
  imageHeight,
  textEllipse,
}) {
  return (
    <div className="rounded shadow animate-pulse">
      <div className={`object-fill w-full bg-gray-200 ${imageHeight}`}></div>
      <div className="mt-2" style={{ padding: "2px" }}>
        <div className="text-xs mb-2 bg-gray-200 h-2"></div>
        <div className="font-bold bg-gray-200 h-2"></div>
        <div
          className={`font-bold text-xs mb-2 bg-gray-200 h-5 ${textEllipse} w-44`}
        ></div>

        <div className={`text-xs bg-gray-200 h-2 ${textEllipse} w-44`}></div>
      </div>
    </div>
  );
}
